import jsonTransformer from "sites-common/utils/jsonTransformer";
import moment from "moment";
import { compute_operators } from "@heartfulnessinstitute/react-hfn-forms/dist/choice_lists";
import { uniq, get, set } from "lodash";

export const specialCharacRegex = new RegExp(/^[aA-zZ0-9 ",.-\s]+$/);

export const eventFormFields = [
  { name: "id", label: "ID", hide: true },
  {
    name: "title",
    label: "Event Title",
    dynamic: (r) => {
      const val = r.title?.replace(/  +/g, " ").trim();
      set(r, "title", val);
    },
  },
  {
    name: "event_json.about",
    label: "Event Description",
    type: "textarea",
    props: { multiline: true },
    dynamic: (r) => {
      const val = r.event_json?.about?.replace(/  +/g, " ").trim();
      set(r, "event_json.about", val);
    },
  },
  {
    name: "start_datetime",
    label: "Start Date",
    type: "datetimetz",
    props: {
      futureDatesOnly: true,
    },
    // dynamic: (r) =>
    //   r.end_datetime && {
    //     props: { ...r.props, maxDate: r.end_datetime },
    //   }
  },
  {
    name: "end_datetime",
    label: "End Date",
    type: "datetimetz",
    props: {
      // futureDatesOnly: true,
    },
    dynamic: (r) =>
      r.start_datetime && {
        props: {
          ...r.props,
          required: true,
          minDate: moment(r.start_datetime).format("YYYY-MM-DDTHH:mm:ssZ"),
        },
      },
  },
  {
    name: "venue",
    label: "Event Venue",
    props: {
      gridWidth: 300,
      description: "Please mention specific office location, if applicable",
    },
  },
  {
    name: "event_json.is_venue_online",
    label: "Venue Online",
    type: "toggle",
  },
  {
    name: "enable_registration",
    label: "Enable Registration",
    type: "toggle",
  },
  {
    name: "display_on_calender",
    label: "Publish in event scheduled list (Calendar)",
    type: "toggle",
  },
  {
    name: "venue_city.id",
    label: "City",
    type: "srcm_city_id",
    props: {
      gridWidth: 300,
      description: "To be displayed in event page",
    },
  },
  {
    name: "category.id",
    label: "Event Category",
    type: "srcm_event_category_id",
    props: {
      description: "Start type your event category (eg: heartfulness)",
    },
  },
  {
    name: "capacity",
    label: "Capacity",
    type: "number",
    props: {
      gridInline: 110,
      description: "Total participants invited",
    },
  },
  {
    name: "event_json.institution",
    label: "Institution",
    type: "text",
    props: {
      gridInline: 300,
      required: false,
      description:
        "Enter name of Organization (Connect events), Sub-center (Group meditation) or Village name (V-Connect).",
    },
  },
  // {
  //   name: "created_by_partner.name",
  //   label: "Event Created By",
  //   type: "email",
  //   props: {
  //     displayOnly: true,
  //     gridInline: 250,
  //     required: false,
  //   },
  // },
  {
    name: "event_json.contact_name",
    label: "Event Co-ordinator from Heartfulness - Name",
    type: "text",
    props: {
      gridInline: 175,
      description:
        "e.g. HFN Family Connect Events, Heartfulness Hyderabad Events, etc.",
    },
  },
  {
    name: "event_json.contact_email",
    label: "Event Co-ordinator from Heartfulness - Email",
    type: "email",
    props: {
      gridInline: 175,
      description: "Publicly displayed on event info page",
    },
  },
  {
    name: "srcm_group.id",
    label: "Organizer's SRCM Center",
    type: "srcm_center_id",
    props: {
      gridWidth: 300,
    },
  },
  {
    name: "tag_strings",
    label: "Tags",
    type: "autosuggest",
    options: [],
    props: {
      required: false,
      gridWidth: 300,
    },
  },
  // {
  //   name: "is_paid_event",
  //   label: "Is Paid Event?",
  //   type: "toggle",
  // },
  {
    type: "statichtml",
    label: "<h5>Paid Event / Donations<h5>",
    name: "x1",
  },
  {
    name: "is_paid_event",
    type: "toggle",
    label: "Does this event have mandatory registration fees?",
  },
  {
    name: "event_json.suggested_donation",
    label: "Suggested Donation",
    type: "number",
    props: {
      min: 100,
      gridInline: 200,
      description: "Per participant",
    },
    dynamic: [
      [
        "hide",
        [
          [":is_paid_event", "IS", "SET"],
          "||",
          [":is_paid_event", "IS", "TRUE"],
        ],
      ],
    ],
  },
  {
    name: "event_json.custom_config_json",
    label: "Custom Config JSON",
    type: "textarea",
    props: {
      multiline: true,
      required: false,
    },
  },
];

export const paidSkuFields = [
  {
    name: "paid_skus",
    label: "Mandatory Fees / SKUs",
    type: "subform:multiple",
    props: {
      add: true,
      delete: true,
    },
    subFormFields: [
      { name: "desc", label: "Description (for website)", type: "text" },
      { name: "rate", label: "Ticket Rate (including GST)", type: "number" },
      {
        name: "sku",
        label: "SKU Code (unique for each rate variant)",
        type: "text",
        props: { placeholder: "eg: 3CBI783" },
      },
      {
        name: "currency",
        label: "Currency",
        type: "select",
        options: [{ name: "INR", label: "INR" }],
      },
      {
        name: "gst",
        label: "GST (%)",
        type: "select",
        options: [{ name: 18, label: "18%" }],
      },
      {
        name: "org",
        label: "Organization",
        type: "select",
        options: [
          { name: "hfi", label: "HFI" },
          { name: "aaram", label: "Aaram" },
        ],
      },
      {
        name: "desc_inv",
        label: "Description for Invoice (if different from website)",
        type: "text",
        props: { required: true },
      },
      {
        name: "num_units",
        label: "No of units",
        type: "number",
      },
      { name: "sac", label: "Sac", type: "text" },

      // {
      //   name: "pconstraints",
      //   label: "SKU Constraints (Optional)",
      //   type: "jsonfield",
      //   props: { required: false },
      // },
    ],
  },
];

export const setupRegFormFields = [
  // {
  //   type: "statichtml",
  //   label: "<h5>Online Registration<h5>",
  //   name: "x7",
  // },
  // {
  //   name: "online_registration",
  //   label: "Setup online registration",
  //   type: "select",
  //   options: [
  //     { name: true, label: "Yes" },
  //     { name: false, label: "No" },
  //   ],
  //   props: {
  //     required: false,
  //   },
  // },
  {
    name: "online_registration",
    type: "checkbox",
    label: "Setup online registration",
    props: { disabled: false },
    dynamic: (r) => {
      if (r.online_registration) {
        set(r, "register_link", null);
      }
    },
  },
  // {
  //   name: "online_registration_publish",
  //   label: "Don't publish in event scheduled list",
  //   type: "select",
  //   options: [
  //     { name: true, label: "Yes" },
  //     { name: false, label: "No" },
  //   ],
  //   props: {
  //     required: false,
  //   },
  // },
  {
    name: "register_link",
    label: "External Website / Link",
    type: "url",
    props: {
      required: false,
      description:
        "Link for eventbrite or meetup or other website for detailed information / registration of the event",
    },
    dynamic: [["hide", [":online_registration", "IS", "SET"]]],
  },
  // {
  //   // name: "show_link",
  //   name: "register_link",
  //   label: "Registrations Link",
  //   type: "url",
  //   props: {
  //     required: false,
  //     description:
  //       "Registration link will generated once after you create an event",
  //     readOnly: true,
  //     style: {
  //       backgroundColor: "#ffff00",
  //     },
  //   },
  //   dynamic: [["hide", [":online_registration", "IS", "NULL"]]],
  // },
  {
    name: "reg_starts",
    label: "Reg Starts on",
    type: "datetimetz",
    props: {
      gridInline: 175,
      futureDatesOnly: true,
    },
    // dynamic: [["hide", [":online_registration", "IS", "NULL"]]],
    dynamic: (r) =>
      r.online_registration && r.start_datetime
        ? {
            props: {
              ...r.props,
              maxDate: r.start_datetime,
            },
          }
        : { hide: true },
  },
  {
    name: "reg_ends",
    label: "Reg Closes on",
    type: "datetimetz",
    props: {
      gridInline: 175,
      futureDatesOnly: true,
    },
    // dynamic: [["hide", [":online_registration", "IS", "NULL"]]],
    dynamic: (r) =>
      r.online_registration && r.reg_starts
        ? {
            props: {
              ...r.props,
              minDate: moment(r.reg_starts).format("YYYY-MM-DDTHH:mm:ssZ"),
              maxDate: r.end_datetime,
            },
          }
        : { hide: true },
  },
  {
    name: "event_json.allow_ids",
    label: "Participants Allowed",
    type: "multiselect",
    props: { required: false },
    options: [
      {
        name: "srcmid",
        label: "Abhyasis with SRCM / HFN ID cards",
      },
      {
        name: "otherid",
        label: "Anyone with some Govt issued ID Cards",
      },
      {
        name: "child",
        label:
          "Children (Select only if this children can participate in this workshop?)",
      },
      {
        name: "noid",
        label:
          "Anyone without any ID cards [NOT TO BE SELECTED FOR EVENTS AT KANHA OR THAT REQUIRE OVERNIGHT STAY AT AN ASHRAM]",
      },
    ],
  },
  {
    name: "event_json.constraints",
    label: "Participant Constraints",
    type: "jsonkv",
    listField: true,
    dynamic: [["hide", [":online_registration", "IS", "NULL"]]],
    props: {
      required: false,
      formfields: [
        {
          name: "field_type",
          label: "Field Type",
          type: "select",
          options: [
            { name: "age_group", label: "Age" },
            { name: "city_id", label: "City" },
            // { name: ":country", label: "Country" },
            // { name: ":state", label: "State" },
          ],
          props: {
            gridWidth: 300,
            required: true,
          },
        },
        {
          name: "condtion",
          label: "Condition",
          type: "select",
          dynamic: (r) => ({
            options:
              r.field_type === "age_group"
                ? compute_operators
                : [
                    { name: "==", label: "equals" },
                    { name: "!=", label: "not equals" },
                  ],
          }),
          props: {
            gridWidth: 300,
            required: true,
          },
        },
        {
          name: "value",
          label: "Value",
          type: "number",
          props: { required: true },
          dynamic: [["hide", [":field_type", "!=", "age_group"]]],
        },
        {
          name: "value",
          label: "Value",
          type: "city",
          props: { required: true },
          dynamic: [["hide", [":field_type", "!=", "city_id"]]],
        },
        { name: "error_msg", label: "Error Message", type: "text" },
      ],
    },
  },
  {
    type: "statichtml",
    label: "<br/>",
    name: "cc1",
  },
  {
    type: "statichtml",
    label: "<br/>",
    name: "cc2",
  },
  {
    name: "reg_needs_approval",
    type: "toggle",
    label:
      "Waitlist upon registration, an organizer will look and confirm later",
    dynamic: (r) => {
      if (!r.reg_needs_approval) {
        set(r, "reg_needs_approval", false);
      }
      if (r.online_registration && r.online_registration === null) {
        return { hide: true };
      }
      return {};
    },
  },
];

export const postprocess = (r) => {
  const ret = jsonTransformer(
    [
      { t: "rel2id", i: ["srcm_group"], o: ["srcm_group"] },
      { t: "rel2id", i: ["venue_city"], o: ["venue_city"] },
      { t: "rel2id", i: ["category"], o: ["category"] },
      { t: "rel2id", i: ["venue_country"], o: ["venue_country"] },
      { t: "relArr2idArr", i: ["organizers"], o: ["organizers"] },
      { t: "omit", i: ["meditation_center"] },
      { t: "omit", i: ["created_by"] },
      { t: "omit", i: ["created_by_partner"] },
      { t: "omit", i: ["write_date"] },
      { t: "omit", i: ["create_date"] },
      { t: "omit", i: ["one_status"] },
      { t: "omit", i: ["id"] },
      { t: "omit", i: ["zone"] },
      { t: "omit", i: ["parent_event"] },
      { t: "omit", i: ["tags"] },
      { t: "copy", i: ["tag_strings"] },
      { t: "copy", i: ["is_paid_event"], o: ["is_paid_event"] },
      { t: "paidSkus", i: ["paid_skus"], o: ["paid_skus"] },
      { t: "omit", i: ["audit_log"] },
      { t: "omit", i: ["log"] },
      { t: "omit", i: ["preview"] },
    ],
    r
  );
  return ret;
};

export const eventFormDefaults = {
  online_registration: false,
  register_link: null,
  is_venue_online: true,
  capacity: 0,
  is_paid_event: false,
  event_json: {},
  paid_skus: [],
  enable_registration: null,
  display_on_calender: null,
  start_datetime: moment().startOf("date").format("YYYY-MM-DDTHH:mm:ssZ"),
  end_datetime: moment()
    .startOf("date")
    .add(2, "d")
    .format("YYYY-MM-DDTHH:mm:ssZ"),
};

export function eventFormvalidations(r) {
  const ej_paid_event = get(r, ["is_paid_event"]);
  const ej_paid_skus = get(r, ["paid_skus"], []);
  if (ej_paid_event) {
    if (ej_paid_skus.length < 1) {
      return "Missing SKUs for Paid Event. Please add one.";
    }
    const u = uniq(ej_paid_skus.map((item) => item.sku));
    if (u.length !== ej_paid_skus.length) {
      return "Duplicate SKUs found in Paid Event Section. Please Correct.";
    }

    const v = uniq(ej_paid_skus.map((item) => item.org));
    if (v.length > 1) {
      return "All SKUs should be from only one org";
    }
  }
  return false;
}

export function myEventsFormValidation(r) {
  const title = get(r, ["title"]);
  const about = get(r, ["event_json", "about"]);

  if (title) {
    if (!specialCharacRegex.test(title.trim())) {
      return "Special Characters not allowed in Event Title";
    }
  }

  if (about) {
    if (!specialCharacRegex.test(about.trim())) {
      return "Special Characters not allowed in Event Description";
    }
  }

  return false;
}
